import React, { Children, cloneElement, isValidElement } from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import {
  isLoggedInSelector,
  isNativeSelector,
} from '../../../redux/reducers/app/params';
import { SEO } from '../../../constants/seo';
import styles from './Breadcrumbs.module.css';

const Breadcrumbs = ({ children, className }) => {
  const isLoggedIn = useSelector(isLoggedInSelector);
  const isNative = useSelector(isNativeSelector);

  return isLoggedIn || isNative ? null : (
    <ol
      className={classNames(styles.component, className)}
      itemScope
      itemType={SEO.TYPES.LIST}
    >
      {Children.toArray(children)
        .filter((child) => isValidElement(child))
        .map((child, index) =>
          cloneElement(child, {
            position: index + 1,
          })
        )}
    </ol>
  );
};

export default Breadcrumbs;
